'use strict';

$(document).on('click', '.expandable-blocks svg.expandable-block-arrow', function (event) {
  var $this = $(this);
  event.preventDefault();
  $this.parent().parent().toggleClass('open-block');
});
